import React, { useEffect, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { responsiveFontSizes, useTheme } from '@mui/material/styles';
import {
  Box, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableFooter,
  TablePagination, TableRow, TableHead, Paper, IconButton, Dialog, DialogActions,
  DialogContent, DialogContentText, DialogTitle, Button, Slide, Snackbar,
  Alert,
  Checkbox,
  Switch,
  FormControlLabel
} from '@mui/material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import AddIcon from '@mui/icons-material/Add';
import {
  FirstPage as FirstPageIcon,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage as LastPageIcon,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import { getMentorData, deleteMentorData, addMentor, editMentor, MentorStatusUpdate } from "../services"; // 👈 adjust path if needed
import { useNavigate } from 'react-router-dom';
import AddPrice from '../component/addpricedialog';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import { safeDecryptId } from '../utils/safeDecryptId';
import { encryptId } from '../utils/encryption';
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Custom pagination actions
function TablePaginationActions({ count, page, rowsPerPage, onPageChange }) {
  const theme = useTheme();

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={(e) => onPageChange(e, 0)} disabled={page === 0}>
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={(e) => onPageChange(e, page - 1)} disabled={page === 0}>
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton onClick={(e) => onPageChange(e, page + 1)} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton onClick={(e) => onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function MentorList() {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [selectedMentorId, setSelectedMentorId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [formDialogOpen, setFormDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState('add'); // or 'edit'
  const [selectedMentorPriceId, setSelectedMentorPriceId] = useState(null);
  const [mentorForm, setMentorForm] = useState({
    email: '',
    name: '',
    college: '',
    phone: '',
    rating: '',
    expertise: '',
    profile: null,
    about: '',
    country_studied_in: "",
    area_of_study: "",
    langauge_spoken1: "",
    langauge_spoken2: "",
    langauge_spoken3: ""
  });
  const [selectedIds, setSelectedIds] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [showActive, setShowActive] = useState(true);

  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const refreshMentorSlots = () => {
    setSelectedMentorPriceId(null)
    // 👇 Call your fetch function here to update list after API success
    // console.log("Refresh mentor slot list...");
  };
  const navigate = useNavigate();
  const handleAddMentor = () => {
    setMentorForm({
      email: '',
      name: '',
      college: '',
      phone: '',
      rating: '',
      expertise: '',
      profile: '',
      about: '',
      country_studied_in: "",
      area_of_study: "",
      langauge_spoken1: "",
      langauge_spoken2: "",
      langauge_spoken3: ""

    });
    setDialogMode('add');
    setFormDialogOpen(true);
  };

  const handleEditMentor = (mentor) => {
    setMentorForm(mentor);
    setDialogMode('edit');
    setFormDialogOpen(true);
  };

  const fetchData = async (isActive = true) => {
    try {
      const res = await getMentorData();
      const filteredData = res.data.filter((mentor) =>
        isActive ? mentor.is_active === 1 : mentor.is_active === 0
      );
      setRows(filteredData);
    } catch (err) {
      console.error('Error fetching mentors:', err);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  useEffect(() => {
    fetchData(showActive);
  }, [showActive]);


  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClickOpen = (id) => {
    setSelectedMentorId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedMentorId(null);
  };

  const handleDeleteConfirm = async () => {
    try {
      const reposnse = await deleteMentorData(selectedMentorId);
      // console.log("resp", reposnse)
      if (reposnse.status === 200) {
        fetchData(showActive); // refresh list
        handleClose();
        setSnackbar({
          open: true,
          message: "Delete successful!",
          severity: "success",
        });
      }

    } catch (err) {
      setSnackbar({
        open: true,
        message: err?.response?.data?.message || "Login failed. Please try again.",
        severity: "error",
      });
    }
  };
  const Price = (id) => {

    setSelectedMentorPriceId(id)
    setOpenDialog(true)
  }
  const handleSubmitSelected = async () => {
    if (selectedIds.length === 0) return;
    console.log("Submitted IDs:", selectedIds);
    try {
      const response = await MentorStatusUpdate({ ids: selectedIds });
      if (response.status === 200) {
        fetchData(showActive)
        setSelectedIds([]);
        setSnackbar({
          open: true,
          message: "Mentor(s) activated successfully!",
          severity: "success",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to activate mentors.",
        severity: "error",
      });
    }
  };

  return (
    <>
      <AddPrice
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onSubmit={refreshMentorSlots}
        selectedMentorPriceId={selectedMentorPriceId}

      />
      <CardContent sx={{
        marginTop:{
          xs:"35px"
        }
      }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={showActive}
                onChange={() => setShowActive((prev) => !prev)}
                color="primary"
              />
            }
            label={showActive ? 'Showing Active Mentors' : 'Showing Inactive Mentors'}
          />


          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleAddMentor}
            >
              Add Mentor
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenConfirm(true)}
              disabled={selectedIds.length === 0}
            >
              Activate Mentor{selectedIds.length > 1 ? 's' : ''}
            </Button>
          </Box>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f0f0f0' }}>
                <TableCell align="center">Name</TableCell>
                <TableCell align="center">Email</TableCell>
                <TableCell align="right">Phone</TableCell>
                <TableCell align="right">College</TableCell>
                <TableCell align="right">Country Studied In</TableCell>
                <TableCell align="right">Field of Study</TableCell>
                <TableCell align="right">Languages Spoken1</TableCell>
                <TableCell align="right">Languages Spoken2</TableCell>
                <TableCell align="right">Languages Spoken3</TableCell>
                <TableCell align="right">Rating</TableCell>
                <TableCell >Status</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : rows
              ).map((row) => (
                <TableRow key={row.id}>
                  <TableCell>
                    {row.is_active === 0 && (
                      <Checkbox
                        checked={selectedIds.includes(row.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedIds((prev) => [...prev, row.id]);
                          } else {
                            setSelectedIds((prev) => prev.filter((id) => id !== row.id));
                          }
                        }}
                      />
                    )}
                    {row.name || ''}
                  </TableCell>

                  <TableCell align="right">{row.email || ''}</TableCell>
                  <TableCell align="right">{row.phone || ''}</TableCell>
                  <TableCell align="right">{row.college || ''}</TableCell>
                  <TableCell align="right">{row.country_studied_in || ''}</TableCell>
                  <TableCell align="right">{row.area_of_study || ''}</TableCell>
                  <TableCell align="right">{row.langauge_spoken1 || ''}</TableCell>
                  <TableCell align="right">{row.langauge_spoken2 || ''}</TableCell>
                  <TableCell align="right">{row.langauge_spoken3 || ''}</TableCell>
                  <TableCell align="right">{row.rating}</TableCell>
                  <TableCell align="right">
                    {row.is_active === 1 ? (
                      <Box
                        component="span"
                        sx={{
                          backgroundColor: 'green',
                          color: 'white',
                          px: 1.5,
                          py: 0.5,
                          borderRadius: 1,
                          fontWeight: 'bold',
                        }}
                      >
                        Active
                      </Box>
                    ) : row.is_active === 0 ? (
                      <Box
                        component="span"
                        sx={{
                          backgroundColor: 'red',
                          color: 'white',
                          px: 1.5,
                          py: 0.5,
                          borderRadius: 1,
                          fontWeight: 'bold',
                        }}
                      >
                        Inactive
                      </Box>
                    ) : null}
                  </TableCell>
                  <TableCell align="right">
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                      <IconButton color="primary" size="small" onClick={() => {
                        const encryptedId = encryptId(row.id, secretKey);
                        console.log("secretKey", secretKey);

                        navigate(`/mentorlist/studentlist/${encryptedId}`);
                      }}>
                        <PersonSearchIcon />
                      </IconButton>
                      <IconButton color="secondary" size="small" onClick={() => handleEditMentor(row)}>
                        <EditIcon />
                      </IconButton>
                      {/* <IconButton color="green" size="small" onClick={() => {
                        const encryptedId = encryptId(row.id, secretKey); 
                        navigate(`/mentor/price/${encryptedId}`);
                      }} >
                        <PriceCheckIcon />
                      </IconButton> */}
                      <IconButton color="error" size="small" onClick={() => handleClickOpen(row.id)}>
                        <DeleteIcon />
                      </IconButton>
                      <IconButton color="blue" size="small" onClick={() => {
                        const encryptedId = encryptId(row.id, secretKey);
                        navigate(`/mentor/timeslot/${encryptedId}`);
                      }}>
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </CardContent>

      {/* Delete Confirmation Dialog */}
      <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={handleClose}>
        <DialogTitle>Delete Mentor</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this mentor?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error">Delete</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={formDialogOpen} onClose={() => setFormDialogOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{dialogMode === 'add' ? 'Add Mentor' : 'Edit Mentor'}</DialogTitle>
        <DialogContent dividers>
          {['name', 'email', 'college', "area_of_study", "country_studied_in", 'phone', 'rating', 'expertise', 'about', "langauge_spoken1", "langauge_spoken2", "langauge_spoken3"].map((field) => (
            <Box key={field} mb={2}>
              <Typography variant="subtitle2" gutterBottom>{field.charAt(0).toUpperCase() + field.slice(1)}</Typography>
              <input
                type="text"
                value={mentorForm[field]}
                onChange={(e) => setMentorForm({ ...mentorForm, [field]: e.target.value })}
                style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: 4 }}
              />
            </Box>
          ))}

          {/* Profile image upload */}
          <Box mb={2}>
            <Typography variant="subtitle2" gutterBottom>Profile Image</Typography>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                setMentorForm({ ...mentorForm, profile: file });
              }}
            />
            {mentorForm.profile && (
              <img
                src={typeof mentorForm.profile === 'string' ? mentorForm.profile : URL.createObjectURL(mentorForm.profile)}
                alt="Profile Preview"
                style={{ marginTop: 10, width: 100, height: 100, borderRadius: '50%', objectFit: 'cover' }}
              />
            )}
          </Box>

        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFormDialogOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={async () => {
              try {
                const formData = new FormData();

                // Append each form field to FormData
                formData.append("email", mentorForm.email);
                formData.append("name", mentorForm.name);
                formData.append("college", mentorForm.college);
                formData.append("country_studied_in", mentorForm.country_studied_in);
                formData.append("area_of_study", mentorForm.area_of_study);
                formData.append("langauge_spoken1", mentorForm.langauge_spoken1);
                formData.append("langauge_spoken2", mentorForm.langauge_spoken2);
                formData.append("langauge_spoken3", mentorForm.langauge_spoken3);
                formData.append("phone", mentorForm.phone);
                formData.append("rating", mentorForm.rating);
                formData.append("expertise", mentorForm.expertise);
                formData.append("about", mentorForm.about);

                // Append file only if it's a File object
                if (mentorForm.profile instanceof File) {
                  formData.append("profile", mentorForm.profile);
                }

                if (dialogMode === 'add') {
                  await addMentor(formData);
                  setSnackbar({
                    open: true,
                    message: 'Mentor added successfully',
                    severity: 'success',
                  });
                } else {
                  await editMentor(mentorForm.id, formData);
                  setSnackbar({
                    open: true,
                    message: 'Mentor updated successfully',
                    severity: 'success',
                  });
                }

                fetchData(showActive);
                setFormDialogOpen(false);
              } catch (error) {
                console.error('Save Error:', error);
                setSnackbar({
                  open: true,
                  message: error?.response?.data?.message || 'Error while saving data',
                  severity: 'error',
                });
              }
            }}
          >
            {dialogMode === 'add' ? 'Add Mentor' : 'Update Mentor'}
          </Button>
        </DialogActions>

      </Dialog>
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Activation</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to activate {selectedIds.length} inactive mentor{selectedIds.length > 1 ? 's' : ''}?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={async () => {
              setOpenConfirm(false);
              await handleSubmitSelected(); // 🔥 API call here
            }}
            color="primary"
            variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
